import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleTextInputDialogComponent } from './simple-text-input-dialog.component';

@Injectable()
export class SimpleTextInputDialogService {

  constructor(private modalService: NgbModal) { }

  public openDialog(
    title: string,
    message: string,
    actionBtnText = 'Confirm',
    declineBtnText,
    inputTextPlaceholder = '',
    dialogSize: 'sm'|'lg' = 'sm',
    isRequiredInput: true,
    acceptAction?: (inputText: string) => Promise<any>,
    inputDefaultValue?: string,
    inputSuffix?: string): Promise<boolean>
  {

    const modalRef = this.modalService.open(SimpleTextInputDialogComponent, { size: dialogSize, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.actionBtnText = actionBtnText;
    modalRef.componentInstance.declineBtnText = declineBtnText;
    modalRef.componentInstance.inputTextPlaceholder = inputTextPlaceholder;
    modalRef.componentInstance.isRequiredInput = isRequiredInput;
    modalRef.componentInstance.acceptAction = acceptAction;

    modalRef.componentInstance.inputSuffix = inputSuffix;

    if(inputDefaultValue && inputDefaultValue !== undefined && inputDefaultValue.length > 0)
      modalRef.componentInstance.inputText = inputDefaultValue;

    return modalRef.result;
  }

}
